import SiteWrapper from "../SiteWrapper.react";
import { useTranslation } from "react-i18next";
import "../css/ProjectDetail.css";
import EstimationService from "../services/estimations.service";
import TaskStateService from "../services/taskState.service";
import UserService from "../services/user.service";
import TaskTypeService from "../services/taskType.service";
import { toast } from "react-toastify";
import SelectMulti from "react-select";
import ProjectTaskService from "../services/projectTask.service";
import { useAuthContext } from "../contexts/AuthenticationContext";
import { User } from "../util/Interfaces";
import ProjectPhaseService from "../services/projectPhase.service";
import { confirmAlert } from "react-confirm-alert";
import ProjectSerivice from "../services/project.service";
import ElementTypeService from "../services/elementType.service";
import {
  Container,
  Card,
  Box,
  TextField,
  MenuItem,
  Button,
  Stack,
  CircularProgress,
  Paper,
  Typography,
  IconButton,
  Switch,
  FormControlLabel,
  Modal,
  Select,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import {
  TrueffortSearchInput,
  TrueffortButton,
  TrueffortSelect,
  HelperDialog,
  TrueffortTextField,
} from "../MUIstyle/MUICustom";
import ProjectDetailElementRow from "../components/projectDetail/ProjectDetailElementRow";
import SummaryCard from "../components/projectDetail/SummaryCard";
import AddElementForm from "../components/projectDetail/AddElementForm";
import {
  Delete as DeleteIcon,
  Save as SaveIcon,
  Close as CloseIcon,
  KeyboardArrowDown,
} from "@mui/icons-material";
import { MIN_LEVEL_ADMIN, MIN_LEVEL_LEADER } from "../util/Constants";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  addNWorkingDaysToADate,
  dateToDateLocale,
  formatSeconds,
} from "../util/GlobalFunctions";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AddIcon from "@mui/icons-material/Add";
import { TaskTypesContext } from "../components/projectDetail/ProjectDetailContext";
import HelpIcon from "@mui/icons-material/Help";
import { helperDialogs } from "../util/HelperDialogs";
import { ExcelFile, ExcelColumn, ExcelSheet } from "../util/ExportExcel";
import { useState, useMemo, useEffect } from "react";
import { formatCurrency } from "../util/DateDataFormat";
import InteroperabilityService from "../services/interoperabilty.service";
import Gantt from "../components/estimation/Gantt";
import PriorityTypeService from "../services/priorityType.service";
import AssignUsersToTask from "../components/projectDetail/AssignUsersToTask";
import AddTaskForm from "../components/projectDetail/AddTaskForm";

const dataSummaryEmpty = {
  name: "",
  finished: 0,
  process: 0,
  created: 0,
  total: 0,
  datasets: {
    datasets: [
      {
        data: [1, 1],
        backgroundColor: ["#78B737", "#F2F2F2"],
        display: true,
        borderWidth: 0,
      },
    ],
  },
  percent: 0,
};

function ProjectDetailPage() {
  const { t } = useTranslation();
  const { user } = useAuthContext() as { user: User };
  const features = user?.instance?.license
    ? user?.instance?.license?.features
    : {};
  const theme = useTheme();
  const belowSmall = useMediaQuery(theme.breakpoints.down("sm"));
  //const matches = useMediaQuery(theme.breakpoints.down('md'));

  const query = new URLSearchParams(window.location.search);
  const idProject = query.get("idProject");
  const [loading, setLoading] = useState(true);
  const [formState, setFormState] = useState({
    isCreating: false,
    isEditing: false,
    showFormAddTask: false,
    showFormAddElement: false,
  });
  const [valuesUsersSelect, setValuesUsersSelect] = useState([]);
  const [valuesUsersSelectFilter, setValuesUsersSelectFilter] = useState([]);
  const [valuesStatusSelectFilter, setValuesStatusSelectFilter] = useState([]);
  const [searchFilterValue, setSearchFilterValue] = useState("");
  const [users, setUsers] = useState([]);
  const [usersAll, setUsersAll] = useState([]);
  const [projectInfo, setProjectInfo] = useState({ elements: [] });
  const [projectInterInfo, setProjectInterInfo] = useState(null);
  const [taskTypes, setTaskTypes] = useState([]);
  const [taskStates, setTaskStates] = useState([]);
  const [elementTypes, setElementTypes] = useState([]);
  const [datasetElements, setDatasetElements] = useState({});
  const [priorityTypes, setPriorityTypes] = useState([]);
  const elementTypeService = useMemo(() => new ElementTypeService(), []);
  const taskStateService = useMemo(() => new TaskStateService(), []);
  const estimationService = useMemo(() => new EstimationService(), []);
  const interoperabilityService = useMemo(
    () => new InteroperabilityService(),
    [],
  );
  const priorityTypeService = useMemo(() => new PriorityTypeService(), []);
  const userService = useMemo(() => new UserService(), []);
  const projectService = useMemo(() => new ProjectSerivice(), []);
  const [elementSummaryData, setElementSummaryData] =
    useState(dataSummaryEmpty);
  const [phasesSummaryData, setPhasesSummaryData] = useState(dataSummaryEmpty);
  const [tasksSummaryData, setTasksSummaryData] = useState(dataSummaryEmpty);
  const [elementsFiltered, setElementsFiltered] = useState([]);
  const [elementsGantt, setElementsGantt] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [canEdit, setCanEdit] = useState(true);
  const [idsLeader, setIdsLeader] = useState([]);
  const [idsLeaderAsigned, setIdsLeaderAsigned] = useState([]);
  const [leaders, setLeaders] = useState([]);
  const [activeHelperDialogIndex, setActiveHelperDialogIndex] = useState(-1);
  const [cost, setCost] = useState({ real: 0, estimate: 0, deviation: 0 });
  const [showModalChangeStatusInter, setShowModalChangeStatus] =
    useState(false);
  const [itemsNotUpdateStates, setItemsNotUpdateStates] = useState([]);
  const [selectAllState, setSelectAllState] = useState(false);
  const [loadingItemsUpdateStates, setLoadingItemsUpdateStates] =
    useState(false);
  const [syncingInteroperability, setSyncingInteroperability] = useState(false);

  useEffect(() => {
    fillProjectInfo();
    fillProjectInfoInter();
    fillUsersAll();
    fillTaskStates();
    fillPriorityTypes();
    if (user.role.accessLevel >= MIN_LEVEL_LEADER) {
      fillLeader();
    }

    const id = setInterval(() => {
      fillProjectInfo();
    }, 60000);
    localStorage.setItem("idDetail", id + "");
    return () =>
      clearInterval(parseInt(localStorage.getItem("idDetail") + "") || 0);
  }, []);

  useEffect(() => {
    if (valuesUsersSelectFilter.length > 0 || valuesStatusSelectFilter.length) {
      handleFilterElements();
    }
  }, [projectInfo]);

  useEffect(() => {
    handleFilterElements();
  }, [valuesStatusSelectFilter, valuesUsersSelectFilter]);

  const fillProjectInfoInter = () => {
    //console.log("fillProjectInfoInter");
    interoperabilityService
      .get(Number(idProject))
      .then((resp: any) => {
        if (resp.status == 200 && resp?.data?.success) {
          setProjectInterInfo(resp.data.data);
        }
      })
      .catch((ex: any) => console.error(ex.message));
  };

  const writeAsyncLoc = async (statusFrom: boolean, showMessage: boolean) => {
    try {
      setSyncingInteroperability(true);

      const resp: any = await interoperabilityService.writeAsync(
        idProject,
        statusFrom,
      );

      if (resp?.data?.success) {
        const itemsNotUpdateStates =
          resp?.data?.status?.itemsNotUpdateStates || [];


        if (itemsNotUpdateStates.length > 0) {
          setItemsNotUpdateStates(itemsNotUpdateStates);
          setShowModalChangeStatus(true);
        }

        if (showMessage) {
          toast.success(
            "Se ha sincronizado la interoperabilidad correctamente",
          );
        }

        fillProjectInfo();
        fillProjectInfoInter();
      } else {
        toast.error("Ocurrió un error al sincronizar la interoperabilidad");
      }
    } catch (error) {
      console.error(error);
      toast.error("Ocurrió un error al sincronizar la interoperabilidad");
    } finally {
      setSyncingInteroperability(false);
    }
  };

  const fillProjectInfo = () => {
    //console.log("fillProjectInfo");
    let req = {
      projects: [Number(idProject)],
    };
    estimationService.projectStructure(req).then(({ data: response }: any) => {
      //console.log("PROJECT ESTIMATE", response);
      if (response.status == "ok") {
        let pro = response.projects[0];
        let eleGantt = JSON.parse(JSON.stringify(pro.elements));
        //console.log(eleGantt);
        let tasks_ = [];
        for (let i = 0; i < eleGantt.length; i++) {
          eleGantt[i].projectPhases = eleGantt[i].phases;
          eleGantt[i].estimatedStartDate = new Date(
            eleGantt[i].estimated_start_date,
          );
          eleGantt[i].estimatedFinishDate = addNWorkingDaysToADate(
            new Date(eleGantt[i].estimated_start_date),
            eleGantt[i].duration,
          );
          for (let j = 0; j < eleGantt[i].projectPhases.length; j++) {
            eleGantt[i].projectPhases[j].projectTasks =
              eleGantt[i].projectPhases[j].tasks;
            eleGantt[i].projectPhases[j].name =
              eleGantt[i].projectPhases[j].type_name;
            eleGantt[i].projectPhases[j].estimatedStartDate = new Date(
              eleGantt[i].projectPhases[j].estimated_start_date,
            );
            eleGantt[i].projectPhases[j].estimatedFinishDate =
              addNWorkingDaysToADate(
                new Date(eleGantt[i].projectPhases[j].estimated_start_date),
                eleGantt[i].projectPhases[j].duration,
              );
            for (
              let k = 0;
              k < eleGantt[i].projectPhases[j].projectTasks.length;
              k++
            ) {
              eleGantt[i].projectPhases[j].projectTasks[k].name =
                eleGantt[i].projectPhases[j].projectTasks[k].type_name;
              let nameTask =
                eleGantt[i].name +
                " - " +
                eleGantt[i].projectPhases[j].name +
                " - " +
                eleGantt[i].projectPhases[j].projectTasks[k].name;
              eleGantt[i].projectPhases[j].projectTasks[k].estimatedStartDate =
                new Date(
                  eleGantt[i].projectPhases[j].projectTasks[k]
                    .estimated_start_date,
                );
              eleGantt[i].projectPhases[j].projectTasks[k].estimatedFinishDate =
                addNWorkingDaysToADate(
                  new Date(
                    eleGantt[i].projectPhases[j].projectTasks[k]
                      .estimated_start_date,
                  ),
                  eleGantt[i].projectPhases[j].projectTasks[k].duration,
                );
              tasks_.push({
                idTask: eleGantt[i].projectPhases[j].projectTasks[k].id,
                name: nameTask,
                idSec:
                  eleGantt[i].projectPhases[j].projectTasks[k].sequentiality_id,
              });
              if (
                eleGantt[i].projectPhases[j].projectTasks[k].priorities.length >
                0
              ) {
                for (
                  let m = 0;
                  m <
                  eleGantt[i].projectPhases[j].projectTasks[k].priorities
                    .length;
                  m++
                ) {
                  eleGantt[i].projectPhases[j].projectTasks[k].priorities[
                    m
                  ].parents = [
                    {
                      data: {
                        id: eleGantt[i].projectPhases[j].projectTasks[k]
                          .priorities[m].parent_task_id,
                      },
                    },
                  ];
                }
              }
            }
          }
        }
        //console.log(eleGantt);
        setElementsGantt(eleGantt);
        setTasks(tasks_);
        // SETEAR EL FILTRO DE USUARIOS CON SÓLO USUARIOS QUE TENGAN ACTIVIDAD
        let cost = 0;
        let estimatedCost = 0;
        let arrUsersTmp: any[] = [];
        let arrUsersTmpIds: number[] = [];
        for (const el of pro.elements) {
          for (const ph of el.phases) {
            for (const tk of ph.tasks) {
              //console.log("tarea");
              //console.log(tk);
              let costByUsers = 0;
              for (const usr of tk.users) {
                cost += usr.hourlyRate * usr.registered_effort;
                costByUsers += usr.hourlyRate;
                let usrObj = {
                  idUser: usr.id,
                  name: usr.name,
                  lastName: usr.lastname,
                  fullname: usr.name + " " + usr.lastname,
                  imageDto: { idImage: usr.image_id, url: usr.image_url },
                };
                if (arrUsersTmpIds.indexOf(usrObj.idUser) == -1) {
                  arrUsersTmpIds.push(usrObj.idUser);
                  arrUsersTmp.push(usrObj);
                }
              }
              if (tk.users.length > 0) {
                estimatedCost += (costByUsers / tk.users.length) * tk.effort;
              }
            }
          }
        }
        //console.log("arrUsersTmp", arrUsersTmp);
        setUsers(
          arrUsersTmp.sort((a, b) =>
            a.name > b.name ? 1 : a.name < b.name ? -1 : 0,
          ),
        );
        setCost({
          real: cost,
          estimate: estimatedCost,
          deviation: estimatedCost - cost,
        });
        setProjectInfo(pro);
        if (
          valuesStatusSelectFilter.length == 0 &&
          valuesUsersSelectFilter.length == 0
        ) {
          setElementsFiltered(pro.elements);
        }

        // Crear los datasets para las gráficas de elementos, fases y tareas terminadas
        let elementsFinished = response.projects[0].elements.filter(
          (el: any) => el.status_id == 4,
        ).length;
        setDatasetElements({
          datasets: [
            {
              data: [
                elementsFinished,
                response.projects[0].elements.length - elementsFinished,
              ],
              backgroundColor: ["#78B737", "#F2F2F2"],
              display: true,
              borderWidth: 0,
            },
          ],
        });

        let elProcess = response.projects[0].elements.filter(
          (el: any) => el.status_id == 2,
        ).length;
        let elCreated = response.projects[0].elements.filter(
          (el: any) => el.status_id == 1,
        ).length;
        setElementSummaryData({
          name: t("home.elements"),
          finished: elementsFinished,
          process: elProcess,
          created: elCreated,
          total: elementsFinished + elProcess + elCreated,
          datasets: [
            {
              data: [
                elementsFinished,
                response.projects[0].elements.length - elementsFinished,
              ],
              backgroundColor: ["#78B737", "#F2F2F2"],
              display: true,
              borderWidth: 0,
            },
          ],
          percent: (
            (elementsFinished / (elementsFinished + elProcess + elCreated)) *
            100
          ).toFixed(0),
        });

        let phasesFinished = 0;
        let phasesProcess = 0;
        let phasesCreated = 0;
        let tasksFinished = 0;
        let tasksProcess = 0;
        let tasksCreated = 0;
        response.projects[0].elements.map((el: any) => {
          phasesProcess += el.phases.filter(
            (ph: any) => ph.status_id == 2,
          ).length;
          phasesFinished += el.phases.filter(
            (ph: any) => ph.status_id == 4,
          ).length;
          phasesCreated += el.phases.filter(
            (ph: any) => ph.status_id == 1,
          ).length;
          el.phases.map((ph: any) => {
            tasksFinished += ph.tasks.filter(
              (tk: any) => tk.status_id == 4,
            ).length;
            tasksProcess += ph.tasks.filter(
              (tk: any) => tk.status_id == 2,
            ).length;
            tasksCreated += ph.tasks.filter(
              (tk: any) => tk.status_id == 1,
            ).length;
          });
        });

        setPhasesSummaryData({
          name: t("home.phases"),
          finished: phasesFinished,
          process: phasesProcess,
          created: phasesCreated,
          total: phasesCreated + phasesProcess + phasesFinished,
          datasets: [
            {
              data: [
                phasesFinished,
                phasesCreated + phasesProcess + phasesFinished - phasesFinished,
              ],
              backgroundColor: ["#78B737", "#F2F2F2"],
              display: true,
              borderWidth: 0,
            },
          ],
          percent: (
            (phasesFinished /
              (phasesCreated + phasesProcess + phasesFinished)) *
            100
          ).toFixed(0),
        });

        setTasksSummaryData({
          name: t("home.tasks"),
          finished: tasksFinished,
          process: tasksProcess,
          created: tasksCreated,
          total: tasksFinished + tasksProcess + tasksCreated,
          datasets: [
            {
              data: [tasksFinished, tasksProcess + tasksCreated],
              backgroundColor: ["#78B737", "#F2F2F2"],
              display: true,
              borderWidth: 0,
            },
          ],
          percent: (
            (tasksFinished / (tasksFinished + tasksProcess + tasksCreated)) *
            100
          ).toFixed(0),
        });
        if (user.role.accessLevel >= MIN_LEVEL_LEADER) {
          fillTaskTypes(response.projects[0].type_id);
        } else {
          setTimeout(function () {
            setLoading(false);
          }, 500);
        }
      } else {
        toast.warning(t(response.code));
        setLoading(false);
      }
    });
  };

  const fillUsersAll = () => {
    // @ts-ignore
    userService.getAll().then(({ data: response }) => {
      if (response.success) {
        setUsersAll(response.data.filter((u: any) => u.isEnabled));
      }
    });
  };

  const fillTaskStates = () => {
    // @ts-ignore
    taskStateService.getAll().then(({ data: response }) => {
      if (Array.isArray(response.data)) {
        setTaskStates(response.data);
      }
    });
  };

  const fillPriorityTypes = () => {
    priorityTypeService.getAll().then(({ data: response }: any) => {
      if (response.success) {
        setPriorityTypes(response.data);
      }
    });
  };

  const fillTaskTypes = (idProjectType: number) => {
    const entrada = {
      project_types: [idProjectType],
      root_level: "tasktypes",
    };

    // @ts-ignore
    estimationService
      .getAccumulatedEstimate(entrada)
      .then(({ data: response }: { data: any }) => {
        if (response.status === "warning") {
          toast.error(t(response.code));
        } else {
          setTaskTypes(response.tasktypes);
        }
        setLoading(false);
      });
  };

  const fillElementTypes = () => {
    // @ts-ignore
    elementTypeService
      .getAllWithTasksByProjectType(projectInfo.type_id)
      .then(({ data: response }: { data: any }) => {
        if (Array.isArray(response.data)) {
          setElementTypes(response.data);
        }
      });
  };

  const deleteProject = () => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="react-confirm-alert-body custom-ui">
            <h3 style={{ marginBottom: "1em" }}>
              {t("project_page.msg_delete_confirm2")}{" "}
              <span className="dark">{projectInfo.name + "?"}</span>
            </h3>
            <p className="red">
              <strong>{t("project_page.msg_delete_confirm3")}</strong>
            </p>
            <div className="react-confirm-alert-button-group">
              <Button
                onClick={() => {
                  setLoading(true);
                  try {
                    // @ts-ignore
                    projectService
                      .delete(idProject)
                      .then(({ data: response }: { data: any }) => {
                        if (response?.internalError) {
                          toast.error(response?.message);
                          setLoading(false);
                          return;
                        }
                        // ENVIAR A LA PANTALLA PRINCIPAL AL CERRA LA NOTIFICACIÓN
                        toast.success(t("project_page.msg_success_delete"), {
                          onClose: () => window.location.replace("/"),
                        });
                        //setLoading(false);
                      })
                      .catch(function (error: any) {
                        toast.error(
                          "Ocurrió un error al eliminar el proyecto.",
                        );
                        setLoading(false);
                      });
                  } catch (error) {
                    console.log(
                      "Error #Users handleDelete" + JSON.stringify(error),
                    );
                    toast.error("Ocurrió un error al eliminar el proyecto.");
                    setLoading(false);
                  }
                  onClose();
                }}
              >
                {t("project_page.msg_delete_task_confirm_yes")}
              </Button>
              <Button onClick={onClose}>
                {t("project_page.msg_delete_task_confirm_no")}
              </Button>
            </div>
          </div>
        );
      },
    });
  };

  function getArrUsersFilterIdsFromValues() {
    let arr: number[] = [];
    valuesUsersSelectFilter.map((usr: any) => {
      arr.push(usr.value);
    });
    return arr;
  }

  function getArrStatusFilterIdsFromValues() {
    let arr: number[] = [];
    valuesStatusSelectFilter.map((st: any) => {
      arr.push(st.value);
    });
    return arr;
  }

  const handleChangeSearchInput = (searchFilter: string) => {
    setSearchFilterValue(searchFilter);
    let items = projectInfo.elements.filter((data: any) => {
      if (searchFilter == "") {
        return projectInfo;
      } else {
        if (data.name.toLowerCase().includes(searchFilter.toLowerCase())) {
          return data;
        }
      }
    });
    // todo: filtrar por nombre de fases y tareas

    // SET ELEMENTS FILTERED
    setElementsFiltered(items);
  };

  /**
   * Manejar el filtrado por STATUS(ES) y/o USUARIO(S)
   **/
  const handleFilterElements = () => {
    let arrStatus = getArrStatusFilterIdsFromValues();
    let arrUsersSelectedIds = getArrUsersFilterIdsFromValues();
    if (arrStatus.length > 0 || arrUsersSelectedIds.length > 0) {
      let elementsWithFilter = [];
      for (const el of projectInfo.elements) {
        let phasesWithFilter = []; // Arreglo de fases que coinciden con el filtro/filtros
        for (const ph of el.phases) {
          let tasksWithFilter = [];
          for (const tk of ph.tasks) {
            if (arrStatus.length > 0 && arrUsersSelectedIds.length > 0) {
              // Aplican los 2 filtros
              if (
                tk.users
                  .map((u: any) => u.id)
                  .some((r: any) => arrUsersSelectedIds.includes(r)) &&
                arrStatus.includes(tk.status_id)
              ) {
                tasksWithFilter.push(tk);
              }
            } else if (arrUsersSelectedIds.length > 0) {
              // Aplica filtro de usuarios
              if (
                tk.users
                  .map((u: any) => u.id)
                  .some((r: any) => arrUsersSelectedIds.includes(r))
              ) {
                tasksWithFilter.push(tk);
              }
            } else {
              // Aplica filtro de status
              if (arrStatus.includes(tk.status_id)) {
                tasksWithFilter.push(tk);
              }
            }
          }

          // Determinar si la fase tiene tareas con el estatus seleccionado
          if (tasksWithFilter.length > 0) {
            let phCopy = JSON.parse(JSON.stringify(ph)); // Copiar sin referencia
            phCopy["tasks"] = tasksWithFilter;
            phasesWithFilter.push(phCopy);
          }
        }

        // Determinar si el elemento tiene fases con tareas con el estatus/usuario seleccionado
        if (phasesWithFilter.length > 0) {
          let elCopy = JSON.parse(JSON.stringify(el)); // Copiar sin referencia
          elCopy["phases"] = phasesWithFilter;
          // Aplicar el filtro de búsqueda, si existe
          if (searchFilterValue != "") {
            if (
              elCopy.name
                .toLowerCase()
                .includes(searchFilterValue.toLowerCase())
            ) {
              elementsWithFilter.push(elCopy);
            }
          } else {
            elementsWithFilter.push(elCopy);
          }
        }
      }

      setElementsFiltered(elementsWithFilter);
    } else {
      if (searchFilterValue != "") {
        handleChangeSearchInput(searchFilterValue);
      } else {
        setElementsFiltered(projectInfo.elements);
      }
    }
  };

  const fillLeader = async () => {
    userService.getLeaders().then(({ data: response }: any) => {
      if (Array.isArray(response)) {
        setLeaders(response);
      }
    });
    userService
      .getLeadersByProject(idProject)
      .then(({ data: response }: any) => {
        if (Array.isArray(response)) {
          let ids = response.map((x: any) => {
            return {
              value: x.idUser,
              label:
                (x?.user.name ? x.user.name : "") +
                " " +
                (x?.user.lastName ? x.user.lastName : "") +
                " " +
                (x?.user.email ? "(" + x.user.email + ")" : ""),
            };
          });
          setIdsLeaderAsigned(ids);
          if (!canEdit)
            setCanEdit(
              (user.role.accessLevel >= MIN_LEVEL_LEADER &&
                ids.find((x: any) => x.value == user.idUser)) ||
                user.role.accessLevel >= MIN_LEVEL_ADMIN,
            );
        }
      });
  };

  const handleOpenHelp = () => {
    setActiveHelperDialogIndex(0);
  };

  const handleClose = () => {
    setActiveHelperDialogIndex(-1);
  };

  const handleActiveHelperChange = () => {
    if (activeHelperDialogIndex === helperDialogs["projectDetail"].length) {
      setActiveHelperDialogIndex(-1);
    } else {
      setActiveHelperDialogIndex((prev: number) => prev + 1);
    }
  };

  const exportData = () => {
    //console.log(elementsFiltered);
    let data: any = [];

    elementsFiltered.forEach((elem: any) => {
      let elem_ = {
        elementName: elem.name,
        elementStatus: elem.status_name,
        elementStartDate: elem.start_date == 0 ? "" : elem.start_date,
        elementEndDate: elem.end_date == 0 ? "" : elem.end_date,
        elementEstimatedFinishDate:
          elem.estimated_finish_date == 0 ? "" : elem.estimated_finish_date,
        elementEffortDeviation:
          elem.registered_effort_hours * 3600 +
            elem.registered_effort_minutes * 60 ==
          0
            ? 0
            : formatSeconds(
                elem.registered_effort_hours * 3600 +
                  elem.registered_effort_minutes * 60 -
                  elem.effort * 3600,
                false,
                false,
                false,
              ),
        elementDaysDeviation: elem.days_deviation,
        elementEstimateDuration: elem.duration,
        elementEstimateEffort: elem.effort,
        elementRealDuration: elem.registered_duration,
        elementRealEffort: elem.registered_effort,
      };
      if (elem.phases.length > 0) {
        elem.phases.forEach((phase: any) => {
          let phase_ = {
            phaseName: phase.type_name,
            phaseStatus: phase.status_name,
            phaseStartDate: phase.start_date == 0 ? "" : phase.start_date,
            phaseEndDate: phase.end_date == 0 ? "" : phase.end_date,
            phaseEstimatedFinishDate:
              phase.estimated_finish_date == 0
                ? ""
                : phase.estimated_finish_date,
            phaseEffortDeviation:
              phase.registered_effort_hours * 3600 +
                phase.registered_effort_minutes * 60 ==
              0
                ? 0
                : formatSeconds(
                    phase.registered_effort_hours * 3600 +
                      phase.registered_effort_minutes * 60 -
                      phase.effort * 3600,
                    false,
                    false,
                    false,
                  ),
            phaseDaysDeviation: phase.days_deviation,
            phaseEstimateDuration: phase.duration,
            phaseEstimateEffort: phase.effort,
            phaseRealDuration: phase.registered_duration,
            phaseRealEffort: phase.registered_effort,
          };
          if (phase.tasks.length > 0) {
            phase.tasks.forEach((task: any) => {
              let task_ = {
                taskName: task.type_name,
                taskStatus: task.status_name,
                taskStartDate: task.start_date == 0 ? "" : task.start_date,
                taskEndDate: task.end_date == 0 ? "" : task.end_date,
                taskEstimatedFinishDate:
                  task.estimated_finish_date == 0
                    ? ""
                    : task.estimated_finish_date,
                taskEffortDeviation:
                  task.registered_effort_hours * 3600 +
                    task.registered_effort_minutes * 60 ==
                  0
                    ? 0
                    : formatSeconds(
                        task.registered_effort_hours * 3600 +
                          task.registered_effort_minutes * 60 -
                          task.effort * 3600,
                        false,
                        false,
                        false,
                      ),
                taskDaysDeviation: task.days_deviation,
                taskEstimateDuration: task.duration,
                taskEstimateEffort: task.effort,
                taskRealDuration: task.registered_duration,
                taskRealEffort: task.registered_effort,
              };
              if (task.users.length > 0) {
                task.users.forEach((user: any) => {
                  let user_ = { userName: user.name + " " + user.lastname };
                  data.push({ ...elem_, ...phase_, ...task_, ...user_ });
                });
              } else {
                data.push({ ...elem_, ...phase_, ...task_ });
              }
            });
          } else {
            data.push({ ...elem_, ...phase_ });
          }
        });
      } else {
        data.push({ ...elem_ });
      }
    });
    return data;
  };

  const getTextElement = (
    text1: any,
    sizeGrid: number,
    text2?: any,
    backgroundColor?: string,
    minHeight?: string,
  ) => {
    return (
      <Grid
        item
        xs={sizeGrid}
        style={{
          padding: 0,
          background: backgroundColor || "",
          minHeight: minHeight || "",
        }}
      >
        <Typography sx={{ fontSize: "0.75rem" }} color="#4A4A4A" align="center">
          {text1}{" "}
          {text2 && (
            <>
              <br />
              {text2}
            </>
          )}
        </Typography>
      </Grid>
    );
  };

  const getStatusGroupKey = (item: any) => {
    return String(
      item.projectElement?.status?.idStatus ??
        item.projectElement?.status?.id ??
        item.projectElement?.status_id ??
        item.idStatus ??
        "",
    );
  };

  const getStatusGroupName = (item: any) => {
    return (
      item.projectElement?.status?.name ??
      item.projectElement?.status_name ??
      item.statusName ??
      "Sin estatus"
    );
  };

  const groupedItemsNotUpdateStates = useMemo(() => {
    const allowedStatusIds = ["2", "3", "4"]; // En Proceso, Cancelada, Terminada

    return allowedStatusIds
      .map((statusId) => {
        const items = itemsNotUpdateStates.filter(
          (item: any) => getStatusGroupKey(item) === statusId,
        );

        return {
          statusId,
          statusName: items.length > 0 ? getStatusGroupName(items[0]) : "",
          items,
        };
      })
      .filter((group) => group.items.length > 0);
  }, [itemsNotUpdateStates]);

  const handleChangeStatusForGroup = (statusId: string, newState: any) => {
    setItemsNotUpdateStates((prev: any[]) =>
      prev.map((item: any) =>
        getStatusGroupKey(item) === statusId ? { ...item, newState } : item,
      ),
    );
  };

  const handleChangeStatusForItem = (globalIndex: number, newState: any) => {
    setItemsNotUpdateStates((prev: any[]) =>
      prev.map((item: any, index: number) =>
        index === globalIndex ? { ...item, newState } : item,
      ),
    );
  };

  const statusSelectMenuProps = {
    PaperProps: {
      sx: {
        maxHeight: 300,
        overflowY: "auto",
        backgroundColor: "#fff",
        color: "#07074E",
      },
    },
    MenuListProps: {
      sx: {
        paddingY: 0,
      },
    },
  };

  return (
    <SiteWrapper>
      <Container>
        <TaskTypesContext.Provider value={taskTypes}>
          <Grid container spacing={1}>
            <Grid item xs={6} md={6}>
              {t("project_tasks_page.title")}
              <h3 style={{ marginBottom: 0 }}>
                {projectInfo.name}&nbsp;
                {projectInfo.name !== undefined && (
                  <IconButton size="small" onClick={handleOpenHelp}>
                    <HelpIcon sx={{ color: "#6875C7" }} />
                  </IconButton>
                )}
              </h3>
              <Typography
                style={{
                  fontSize: "0.85rem",
                  fontWeight: "700",
                  marginBottom: "0.5em",
                }}
              >
                {t("project_page.registred_date") +
                  ": " +
                  (projectInfo.registred_date
                    ? projectInfo.registred_date
                    : "")}
              </Typography>
            </Grid>
            <Grid item xs={1} />
            <Grid item xs={5} container>
              {user.role.accessLevel >= MIN_LEVEL_LEADER && (
                <>
                  {user.role.accessLevel >= MIN_LEVEL_ADMIN &&
                    projectInterInfo && (
                      <Grid
                        item
                        xs={12}
                        style={{
                          display: "flex",
                          justifyContent: "end",
                          flexDirection: "row",
                        }}
                      >
                        <FormControlLabel
                          control={
                            <Switch
                              checked={
                                projectInterInfo?.projectInteroperability
                                  ?.statusFromTrue
                              }
                              onChange={(ev: any) =>
                                setProjectInterInfo({
                                  conexion: projectInterInfo.conexion,
                                  elements: projectInterInfo.elements,
                                  projectInteroperability: {
                                    ...projectInterInfo.projectInteroperability,
                                    statusFromTrue: ev.target.checked,
                                  },
                                })
                              }
                            />
                          }
                          label={"Gestionar estados desde Trueffort"}
                        />
                        <TrueffortButton
                          id="idBtnSyncInteroperability"
                          color="primary"
                          variant="contained"
                          size="small"
                          disabled={syncingInteroperability}
                          onClick={() => {
                            writeAsyncLoc(
                              projectInterInfo.projectInteroperability
                                ?.statusFromTrue,
                              true,
                            );
                          }}
                        >
                          {syncingInteroperability ? (
                            <CircularProgress size={18} color="inherit" />
                          ) : (
                            "Sincronizar Interoperabilidad"
                          )}
                        </TrueffortButton>
                      </Grid>
                    )}
                  <Grid
                    item
                    xs={12}
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      flexDirection: "row",
                    }}
                  >
                    {features.exportProjectToExcel && (
                      <ExcelFile
                        element={
                          <Box style={{ paddingRight: "0.5em" }}>
                            <TrueffortButton
                              id="idBtnExportProject"
                              color="primary"
                              variant="contained"
                            >
                              {"Exportar"}
                            </TrueffortButton>
                          </Box>
                        }
                        filename={"Proyecto"}
                      >
                        <ExcelSheet data={() => exportData()} name="Datos">
                          <ExcelColumn
                            label={t("project_tasks_page.element_name")}
                            value={"elementName"}
                          />
                          <ExcelColumn
                            label={t("home.status")}
                            value={"elementStatus"}
                          />
                          <ExcelColumn
                            label={t("start_date")}
                            value={"elementStartDate"}
                          />
                          <ExcelColumn
                            label={t("end_date")}
                            value={"elementEndDate"}
                          />
                          <ExcelColumn
                            label={t(
                              "project_tasks_page.estimated_finish_date",
                            )}
                            value={"elementEstimatedFinishDate"}
                          />
                          <ExcelColumn
                            label={t("project_tasks_page.effort_deviation")}
                            value={"taskEffortDeviation"}
                          />
                          <ExcelColumn
                            label={t("project_tasks_page.days_deviation")}
                            value={"elementDaysDeviation"}
                          />
                          <ExcelColumn
                            label={t("project_tasks_page.estimated_duration")}
                            value={"elementEstimateDuration"}
                          />
                          <ExcelColumn
                            label={t("project_tasks_page.estimated_effort")}
                            value={"elementEstimateEffort"}
                          />
                          <ExcelColumn
                            label={t("project_tasks_page.registered_duration")}
                            value={"elementRealDuration"}
                          />
                          <ExcelColumn
                            label={t("project_tasks_page.registered_effort")}
                            value={"elementRealEffort"}
                          />
                          <ExcelColumn
                            label={t("project_tasks_page.phase_name")}
                            value={"phaseName"}
                          />
                          <ExcelColumn
                            label={t("home.status")}
                            value={"phaseStatus"}
                          />
                          <ExcelColumn
                            label={t("start_date")}
                            value={"phaseStartDate"}
                          />
                          <ExcelColumn
                            label={t("end_date")}
                            value={"phaseEndDate"}
                          />
                          <ExcelColumn
                            label={t(
                              "project_tasks_page.estimated_finish_date",
                            )}
                            value={"phaseEstimatedFinishDate"}
                          />
                          <ExcelColumn
                            label={t("project_tasks_page.days_deviation")}
                            value={"phaseDaysDeviation"}
                          />
                          <ExcelColumn
                            label={t("project_tasks_page.estimated_duration")}
                            value={"phaseEstimateDuration"}
                          />
                          <ExcelColumn
                            label={t("project_tasks_page.estimated_effort")}
                            value={"phaseEstimateEffort"}
                          />
                          <ExcelColumn
                            label={t("project_tasks_page.registered_duration")}
                            value={"phaseRealDuration"}
                          />
                          <ExcelColumn
                            label={t("project_tasks_page.registered_effort")}
                            value={"phaseRealEffort"}
                          />
                          <ExcelColumn
                            label={t("project_tasks_page.task_name")}
                            value={"taskName"}
                          />
                          <ExcelColumn
                            label={t("home.status")}
                            value={"taskStatus"}
                          />
                          <ExcelColumn
                            label={t("start_date")}
                            value={"taskStartDate"}
                          />
                          <ExcelColumn
                            label={t("end_date")}
                            value={"taskEndDate"}
                          />
                          <ExcelColumn
                            label={t(
                              "project_tasks_page.estimated_finish_date",
                            )}
                            value={"taskEstimatedFinishDate"}
                          />
                          <ExcelColumn
                            label={t("project_tasks_page.days_deviation")}
                            value={"taskDaysDeviation"}
                          />
                          <ExcelColumn
                            label={t("project_tasks_page.estimated_duration")}
                            value={"taskEstimateDuration"}
                          />
                          <ExcelColumn
                            label={t("project_tasks_page.estimated_effort")}
                            value={"taskEstimateEffort"}
                          />
                          <ExcelColumn
                            label={t("project_tasks_page.registered_duration")}
                            value={"taskRealDuration"}
                          />
                          <ExcelColumn
                            label={t("project_tasks_page.registered_effort")}
                            value={"taskRealEffort"}
                          />
                          <ExcelColumn label={t("User")} value={"userName"} />
                        </ExcelSheet>
                      </ExcelFile>
                    )}
                    <Box style={{ paddingRight: "0.5em" }}>
                      <TrueffortButton
                        id="idBtnDeleteProject"
                        color="gray"
                        variant="outlined"
                        onClick={deleteProject}
                      >
                        <DeleteIcon sx={{ fontSize: "1.1rem" }} />
                        {t("erase")}
                      </TrueffortButton>
                    </Box>
                  </Grid>
                </>
              )}
            </Grid>
          </Grid>
          <Modal
            open={showModalChangeStatusInter}
            onClose={() => setShowModalChangeStatus(false)}
          >
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                minWidth: "800px",
                maxWidth: "1200px",
                maxHeight: "85vh",
                overflowY: "auto",
                bgcolor: "background.paper",
                border: "2px solid #000",
                boxShadow: 24,
                p: 4,
              }}
            >
              {loadingItemsUpdateStates ? (
                <div style={{ margin: "0 auto", width: "100px" }}>
                  <CircularProgress />
                </div>
              ) : (
                <Grid container spacing={1}>
                  <span>
                    {
                      "Elementos que no pueden ser sincronizados automaticamente. Seleccione el estado correcto y pulse aceptar"
                    }
                  </span>
                  {groupedItemsNotUpdateStates.map((group: any) => {
                    const firstItem = group.items[0];

                    return (
                      <Grid
                        item
                        container
                        sm={12}
                        key={group.statusId}
                        spacing={1}
                        sx={{
                          border: "1px solid #e0e0e0",
                          borderRadius: "8px",
                          padding: "12px",
                          marginTop: "12px",
                        }}
                      >
                        <Grid
                          item
                          sm={8}
                          xs={12}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Typography fontWeight={700}>
                            {group.statusName}
                          </Typography>
                        </Grid>

                        <Grid item sm={4} xs={12}>
                          <Select
                            size="small"
                            sx={{
                              backgroundColor: "#F5F5F5",
                              color: "#07074E",
                            }}
                            MenuProps={statusSelectMenuProps}
                            IconComponent={KeyboardArrowDown}
                            displayEmpty
                            fullWidth
                            value=""
                            onChange={(e) => {
                              handleChangeStatusForGroup(
                                group.statusId,
                                e.target.value,
                              );
                            }}
                          >
                            <MenuItem value="" disabled>
                              Seleccionar para todos
                            </MenuItem>

                            {firstItem.states.map((state: any) => (
                              <MenuItem
                                key={state.idStatusInteroperability}
                                value={state.idStatusInteroperability}
                              >
                                {state.statusTool?.name ?? state.idStatusInteroperability} 
                              </MenuItem>
                            ))}
                          </Select>
                        </Grid>

                        {group.items.map((item: any) => {
                          const globalIndex = itemsNotUpdateStates.findIndex(
                            (x: any) =>
                              x.projectElement?.idProjectElement ===
                              item.projectElement?.idProjectElement,
                          );

                          return (
                            <Grid
                              item
                              container
                              sm={12}
                              xs={12}
                              key={item.projectElement?.idProjectElement}
                              spacing={1}
                              alignItems="center"
                            >
                              <Grid item sm={8} xs={12}>
                                <TrueffortTextField
                                  disabled
                                  value={item.projectElement?.name}
                                  fullWidth
                                  size="small"
                                />
                              </Grid>

                              <Grid item sm={4} xs={12}>
                                <Select
                                  id="project-type-select"
                                  name="Project"
                                  size="small"
                                  sx={{
                                    backgroundColor: "#F5F5F5",
                                    color: "#07074E",
                                  }}
                                  MenuProps={statusSelectMenuProps}
                                  IconComponent={KeyboardArrowDown}
                                  displayEmpty
                                  fullWidth
                                  value={item?.newState || ""}
                                  onChange={(e) => {
                                    handleChangeStatusForItem(
                                      globalIndex,
                                      e.target.value,
                                    );
                                  }}
                                >
                                  <MenuItem value="" disabled>
                                    Seleccionar estado
                                  </MenuItem>

                                  {item.states.map((state: any) => (
                                    <MenuItem
                                      key={state.idStatusInteroperability}
                                      value={state.idStatusInteroperability}
                                    >
                                      {state.statusTool?.name ?? state.idStatusInteroperability}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </Grid>
                            </Grid>
                          );
                        })}
                      </Grid>
                    );
                  })}
                  {selectAllState && (
                    <span>
                      {"Debe seleccionar un estado para todas las tareas."}
                    </span>
                  )}
                  <Grid
                    item
                    xs={12}
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <TrueffortButton
                      color="error"
                      variant="contained"
                      size="small"
                      onClick={() => setShowModalChangeStatus(false)}
                    >
                      {t("elements.buttons.cancel")}
                    </TrueffortButton>
                    <div style={{ marginLeft: "0.5em" }} />
                    <TrueffortButton
                      color="primary"
                      variant="contained"
                      size="small"
                      onClick={() => {
                        let review = itemsNotUpdateStates.some(
                          (its: any) => !its?.newState,
                        );
                        if (review) {
                          setSelectAllState(true);
                          return;
                        }
                        setSelectAllState(false);
                        setLoadingItemsUpdateStates(true);
                        let data: any = {
                          idProject: idProject,
                          statusFromTrue:
                            projectInterInfo?.projectInteroperability
                              ?.statusFromTrue,
                          projectElements: itemsNotUpdateStates.map(
                            (its: any) => ({
                              idProjectElement:
                                its.projectElement?.idProjectElement,
                              name: its.projectElement?.name,
                              newState: its?.newState,
                            }),
                          ),
                        };
                        interoperabilityService
                          .sendNewStatus(data)
                          .then((resp: any) => {
                            if (resp?.data.success) {
                              setLoadingItemsUpdateStates(false);
                              setShowModalChangeStatus(false);
                            }
                          })
                          .catch(() => setLoadingItemsUpdateStates(false));
                      }}
                    >
                      {t("elements.buttons.accept")}
                    </TrueffortButton>
                  </Grid>
                </Grid>
              )}
            </Box>
          </Modal>
          <Grid container spacing={2}>
            <Grid xs={12} md={6}>
              <HelperDialog
                title={t(helperDialogs["projectDetail"][0].title)}
                body={t(helperDialogs["projectDetail"][0].body)}
                dialogIndex={0}
                totalDialogs={helperDialogs["projectDetail"].length}
                isOpen={activeHelperDialogIndex === 0}
                handleNext={handleActiveHelperChange}
                handleClose={handleClose}
                position="right"
              >
                <Card sx={{ background: "#F5F5F5", padding: "6px" }}>
                  {t("project_tasks_page.automatic_estimation")}
                  <Grid container spacing={1}>
                    <Grid xs={6}>
                      <Card sx={{ padding: "12px", textAlign: "center" }}>
                        <h5>{t("project_tasks_page.estimated_duration")}</h5>
                        <h2 style={{ marginBottom: 0 }}>
                          {projectInfo?.duration?.toLocaleString()}
                          {belowSmall && <br />} {t("estimation_page.days")}
                        </h2>
                      </Card>
                    </Grid>
                    <Grid xs={6}>
                      <Card sx={{ padding: "12px", textAlign: "center" }}>
                        <h5>{t("project_tasks_page.estimated_effort")}</h5>
                        <h2 style={{ marginBottom: 0 }}>
                          {formatSeconds(
                            projectInfo?.effort * 3600,
                            false,
                            false,
                            false,
                          )}
                          {belowSmall && <br />}{" "}
                          {user.timeFormat == "dec"
                            ? t("estimation_page.man_hours")
                            : ""}
                        </h2>
                      </Card>
                    </Grid>
                  </Grid>
                </Card>
              </HelperDialog>
            </Grid>
            <Grid xs={12} md={6}>
              <HelperDialog
                title={t(helperDialogs["projectDetail"][1].title)}
                body={t(helperDialogs["projectDetail"][1].body)}
                dialogIndex={1}
                totalDialogs={helperDialogs["projectDetail"].length}
                isOpen={activeHelperDialogIndex === 1}
                handleNext={handleActiveHelperChange}
                handleClose={handleClose}
                position="left"
              >
                <Card
                  sx={{ background: "#050536", color: "white", padding: "6px" }}
                >
                  {t("project_tasks_page.registered_in_trueffort")}
                  <Grid container spacing={1}>
                    <Grid xs={6}>
                      <Card sx={{ padding: "12px", textAlign: "center" }}>
                        <h5>{t("project_tasks_page.registered_duration")}</h5>
                        <h2 style={{ marginBottom: 0 }}>
                          {projectInfo?.registered_duration?.toLocaleString()}
                          {belowSmall && <br />} {t("estimation_page.days")}
                        </h2>
                      </Card>
                    </Grid>
                    <Grid xs={6}>
                      <Card sx={{ padding: "12px", textAlign: "center" }}>
                        <h5>{t("project_tasks_page.registered_effort")}</h5>
                        <h2 style={{ marginBottom: 0 }}>
                          {typeof projectInfo?.registered_effort_hours ==
                          "undefined"
                            ? "--"
                            : formatSeconds(
                                projectInfo?.registered_effort_hours * 3600 +
                                  projectInfo?.registered_effort_minutes * 60,
                                false,
                                false,
                                false,
                              )}
                          {belowSmall && <br />}
                          {user.timeFormat == "dec"
                            ? " " + t("project_tasks_page.hp")
                            : ""}
                        </h2>
                      </Card>
                    </Grid>
                  </Grid>
                </Card>
              </HelperDialog>
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid xs={4} md={4}>
              <HelperDialog
                title={t(helperDialogs["projectDetail"][2].title)}
                body={t(helperDialogs["projectDetail"][2].body)}
                dialogIndex={2}
                totalDialogs={helperDialogs["projectDetail"].length}
                isOpen={activeHelperDialogIndex === 2}
                handleNext={handleActiveHelperChange}
                handleClose={handleClose}
                position="right"
              >
                <Card sx={{ background: "#D7EBF0", padding: "6px" }}>
                  {t("project_tasks_page.estimated_project_cost")}
                  <Grid container spacing={1}>
                    <Grid xs={12}>
                      <Card sx={{ padding: "12px", textAlign: "center" }}>
                        <h2 style={{ marginBottom: 0 }}>
                          {belowSmall && <br />} {formatCurrency(cost.estimate)}
                        </h2>
                      </Card>
                    </Grid>
                  </Grid>
                </Card>
              </HelperDialog>
            </Grid>
            <Grid xs={4} md={4}>
              <HelperDialog
                title={t(helperDialogs["projectDetail"][3].title)}
                body={t(helperDialogs["projectDetail"][3].body)}
                dialogIndex={3}
                totalDialogs={helperDialogs["projectDetail"].length}
                isOpen={activeHelperDialogIndex === 3}
                handleNext={handleActiveHelperChange}
                handleClose={handleClose}
                position="left"
              >
                <Card sx={{ background: "#CFF1AB", padding: "6px" }}>
                  {t("project_tasks_page.real_project_cost")}
                  <Grid container spacing={1}>
                    <Grid xs={12}>
                      <Card sx={{ padding: "12px", textAlign: "center" }}>
                        <h2 style={{ marginBottom: 0 }}>
                          {belowSmall && <br />} {formatCurrency(cost.real)}
                        </h2>
                      </Card>
                    </Grid>
                  </Grid>
                </Card>
              </HelperDialog>
            </Grid>
            <Grid xs={4} md={4}>
              <HelperDialog
                title={t(helperDialogs["projectDetail"][4].title)}
                body={t(helperDialogs["projectDetail"][4].body)}
                dialogIndex={4}
                totalDialogs={helperDialogs["projectDetail"].length}
                isOpen={activeHelperDialogIndex === 4}
                handleNext={handleActiveHelperChange}
                handleClose={handleClose}
                position="right"
              >
                <Card sx={{ background: "#DFDFDF", padding: "6px" }}>
                  {t("project_tasks_page.deviation_project_cost")}
                  <Grid container spacing={1}>
                    <Grid xs={12}>
                      <Card
                        sx={{
                          padding: "12px",
                          textAlign: "center",
                          color: cost.deviation < 0 ? "crimson" : "",
                        }}
                      >
                        <h2 style={{ marginBottom: 0 }}>
                          {belowSmall && <br />}{" "}
                          {formatCurrency(cost.deviation)}
                        </h2>
                      </Card>
                    </Grid>
                  </Grid>
                </Card>
              </HelperDialog>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <HelperDialog
              title={t(helperDialogs["projectDetail"][5].title)}
              body={t(helperDialogs["projectDetail"][5].body)}
              dialogIndex={5}
              totalDialogs={helperDialogs["projectDetail"].length}
              isOpen={activeHelperDialogIndex === 5}
              handleNext={handleActiveHelperChange}
              handleClose={handleClose}
              position="right"
            >
              <Grid xs={12} md={4}>
                <SummaryCard key={11} data={elementSummaryData} />
              </Grid>
            </HelperDialog>
            <HelperDialog
              title={t(helperDialogs["projectDetail"][6].title)}
              body={t(helperDialogs["projectDetail"][6].body)}
              dialogIndex={6}
              totalDialogs={helperDialogs["projectDetail"].length}
              isOpen={activeHelperDialogIndex === 6}
              handleNext={handleActiveHelperChange}
              handleClose={handleClose}
              position="right"
            >
              <Grid xs={12} md={4}>
                <SummaryCard key={12} data={phasesSummaryData} />
              </Grid>
            </HelperDialog>
            <HelperDialog
              title={t(helperDialogs["projectDetail"][7].title)}
              body={t(helperDialogs["projectDetail"][7].body)}
              dialogIndex={7}
              totalDialogs={helperDialogs["projectDetail"].length}
              isOpen={activeHelperDialogIndex === 7}
              handleNext={handleActiveHelperChange}
              handleClose={handleClose}
              position="left"
            >
              <Grid xs={12} md={4}>
                <SummaryCard key={13} data={tasksSummaryData} />
              </Grid>
            </HelperDialog>
          </Grid>

          <Grid
            container
            spacing={1}
            sx={{ marginTop: ".4rem", marginBottom: ".2rem" }}
          >
            <Grid xs={12} md={4}>
              <TrueffortSearchInput
                id="idSearchInput"
                placeholder={t("search")}
                variant="outlined"
                size="small"
                fullWidth
                onChange={(e: any) => handleChangeSearchInput(e.target.value)}
              />
            </Grid>
            <Grid xs={12} md={4}>
              <SelectMulti
                isMulti
                label={t("home.status")}
                placeholder={t("project_page.status_activity")}
                value={valuesStatusSelectFilter}
                options={taskStates.map((s: any, k: number) => {
                  return {
                    value: s.idStatus,
                    label: s.name,
                  };
                })}
                onChange={(option: any) => {
                  setValuesStatusSelectFilter(option);
                }}
              />
            </Grid>
            <Grid xs={12} md={4}>
              {user.role.accessLevel >= MIN_LEVEL_LEADER && (
                <SelectMulti
                  isMulti
                  label={t("User")}
                  placeholder={t("User")}
                  value={valuesUsersSelectFilter}
                  options={users.map((u: any, k: number) => {
                    return {
                      value: u.idUser,
                      label: u.fullname,
                    };
                  })}
                  onChange={(option: any) => {
                    setValuesUsersSelectFilter(option);
                  }}
                />
              )}
            </Grid>
            {(valuesStatusSelectFilter.length > 1 ||
              valuesUsersSelectFilter.length > 1) && (
              <Grid xs={0} md={12}></Grid>
            )}
            <Grid xs={12} md={12}>
              {user.role.accessLevel >= MIN_LEVEL_LEADER && (
                <Stack direction={{ xs: "column", md: "row" }} spacing={1}>
                  {user.role.accessLevel >= MIN_LEVEL_ADMIN && (
                    <TrueffortButton
                      id="idBtnNewLeader"
                      fullWidth
                      color="primary"
                      variant="contained"
                      onClick={() => {
                        setFormState({
                          ...formState,
                          showFormAddLeader: true,
                          showFormAddTask: false,
                          showFormAddElement: false,
                        });
                        setIdsLeader(idsLeaderAsigned);
                      }}
                    >
                      + {t("role.rLeader")}
                    </TrueffortButton>
                  )}
                  <TrueffortButton
                    id="idBtnNewElement"
                    onClick={() => {
                      fillElementTypes();
                      setFormState({
                        ...formState,
                        isCreating: true,
                        showFormAddElement: true,
                        showFormAddTask: false,
                        showFormAddLeader: false,
                      });
                    }}
                    fullWidth
                    color="primary"
                    variant="contained"
                  >
                    + {t("estimation_page.element")}
                  </TrueffortButton>
                  <TrueffortButton
                    id="idBtnNewTask"
                    onClick={() => {
                      fillElementTypes();
                      setFormState({
                        ...formState,
                        isCreating: true,
                        showFormAddElement: false,
                        showFormAddTask: true,
                      });
                    }}
                    fullWidth
                    color="primary"
                    variant="contained"
                  >
                    + {t("project_page.new_task")}
                  </TrueffortButton>
                  <TrueffortButton
                    id="idBtnAssign"
                    onClick={() => {
                      setFormState({
                        ...formState,
                        isCreating: true,
                        showFormAddElement: false,
                        showFormAddTask: false,
                        showFormAssign: true,
                      });
                    }}
                    fullWidth
                    color="primary"
                    variant="contained"
                  >
                    + {"Asignar tareas"}
                  </TrueffortButton>
                </Stack>
              )}
            </Grid>
          </Grid>

          {!loading && formState.showFormAddTask && (
            <AddTaskForm
              _fillproject={fillProjectInfo}
              project={projectInfo}
              t={t}
              users={usersAll}
              setFormState={setFormState}
              formState={formState}
            />
          )}

          {!loading && formState.showFormAddElement && (
            <AddElementForm
              t={t}
              formState={formState}
              setFormState={setFormState}
              elementTypes={elementTypes}
              project={{
                idProject: projectInfo.id,
                idProjectType: projectInfo.type_id,
              }}
              _fillProjectInfo={fillProjectInfo}
            />
          )}

          {!loading && formState.showFormAssign && (
            <AssignUsersToTask
              users={usersAll}
              t={t}
              formState={formState}
              setFormState={setFormState}
              project={projectInfo}
              _fillProjectInfo={fillProjectInfo}
            />
          )}

          {!loading && formState.showFormAddLeader && (
            <Card sx={{ padding: "1rem", overflow: "unset" }}>
              <h6>{t("leader.add")}</h6>
              <Grid container spacing={2}>
                <Grid xs={12} sm={6} md={4}>
                  <SelectMulti
                    id="idSlNewLeader"
                    sx={{ background: "white" }}
                    size="small"
                    isMulti
                    label={t("leader.assign")}
                    name="idLeader"
                    value={idsLeader}
                    onChange={(option: any) => {
                      setIdsLeader(option);
                    }}
                    options={leaders.map((leader: any) => {
                      return {
                        value: leader.idUser,
                        label:
                          (leader?.name ? leader.name : "") +
                          " " +
                          (leader?.lastName ? leader.lastName : "") +
                          " " +
                          (leader?.email ? "(" + leader.email + ")" : ""),
                      };
                    })}
                  />
                </Grid>
                <Grid xs={12} sm={6} md={4}>
                  <TrueffortButton
                    onClick={() => {
                      projectService
                        .assignLeaderes(
                          idsLeader.map((l: any) => {
                            return { idUser: l.value, idProject: idProject };
                          }),
                        )
                        .then(({ data: response_ }: any) => {
                          if (response_.success) {
                            toast.success(
                              t("project_page.msg_success_assign_leader"),
                            );
                            setIdsLeaderAsigned(
                              response_.data.map((x: any) => {
                                return {
                                  value: x.idUser,
                                  label:
                                    (x?.user?.name ? x.user.name : "") +
                                    " " +
                                    (x?.user?.lastName ? x.user.lastName : "") +
                                    " " +
                                    (x?.user?.email
                                      ? "(" + x.user.email + ")"
                                      : ""),
                                };
                              }),
                            );
                          } else {
                            toast.error(response_.message);
                          }
                        })
                        .finally(() =>
                          setFormState({
                            ...formState,
                            showFormAddLeader: false,
                          }),
                        );
                    }}
                  >
                    <SaveIcon />
                  </TrueffortButton>
                  <TrueffortButton
                    color="gray"
                    onClick={() => {
                      setFormState({ ...formState, showFormAddLeader: false });
                      setIdsLeader([]);
                    }}
                  >
                    <CloseIcon />
                  </TrueffortButton>
                </Grid>
              </Grid>
            </Card>
          )}

          {loading && (
            <div style={{ margin: "0 auto", width: "100px" }}>
              <CircularProgress />
            </div>
          )}

          {!loading && (
            <Card
              sx={{ padding: "12px", marginTop: ".4rem", overflowX: "scroll" }}
              className="background-gray"
            >
              {user.role.accessLevel >= MIN_LEVEL_ADMIN &&
                idsLeaderAsigned.length > 0 && (
                  <div>
                    <span
                      className="color-sand600"
                      style={{ fontSize: ".8rem" }}
                    >
                      <strong>{t("project_page.leaders")}</strong>
                    </span>
                    <ul>
                      {idsLeaderAsigned.map((l: any) => (
                        <li style={{ fontSize: ".8rem" }}>{l.label}</li>
                      ))}
                    </ul>
                  </div>
                )}

              <HelperDialog
                title={t(helperDialogs["projectDetail"][8].title)}
                body={t(helperDialogs["projectDetail"][8].body)}
                dialogIndex={8}
                totalDialogs={helperDialogs["projectDetail"].length}
                isOpen={activeHelperDialogIndex === 8}
                handleNext={handleActiveHelperChange}
                handleClose={handleClose}
              >
                <Box sx={{ minWidth: "970px" }}>
                  <Paper
                    variant="outlined"
                    square
                    sx={{ padding: "0px", backgroundColor: "#F5F5F5" }}
                  >
                    <Grid
                      container
                      spacing={1}
                      alignItems="center"
                      style={{ "--Grid-rowSpacing": "0px" }}
                    >
                      <Grid
                        item
                        xs={6}
                        style={{ paddingTop: "10px", minHeight: "36px" }}
                      >
                        <Stack direction="row" spacing={2}>
                          <Typography
                            sx={{
                              fontSize: "1em",
                              display: "flex",
                              alignItems: "center",
                            }}
                            color="#4A4A4A"
                          >
                            <AppRegistrationIcon
                              fontSize="small"
                              sx={{ marginRight: "6px" }}
                            />
                            {t("project_page.template") +
                              ": " +
                              projectInfo.type_name}
                          </Typography>

                          <Typography
                            sx={{
                              fontSize: "1em",
                              display: "flex",
                              alignItems: "center",
                            }}
                            color="#4A4A4A"
                          >
                            <AssignmentIcon
                              fontSize="small"
                              sx={{ marginRight: "6px" }}
                            />
                            {t("project_page.defined_tasks") +
                              ": " +
                              projectInfo.total_tasks}
                          </Typography>
                        </Stack>
                      </Grid>
                      <HelperDialog
                        title={t(helperDialogs["projectDetail"][14].title)}
                        body={t(helperDialogs["projectDetail"][14].body)}
                        dialogIndex={14}
                        totalDialogs={helperDialogs["projectDetail"].length}
                        isOpen={activeHelperDialogIndex === 14}
                        handleNext={handleActiveHelperChange}
                        handleClose={handleClose}
                      >
                        <Grid
                          item
                          xs={1.8}
                          style={{
                            paddingTop: "10px",
                            marginTop: "0px",
                            background: "#D7EBF0",
                            minHeight: "36px",
                          }}
                        >
                          <Typography
                            sx={{ fontSize: "0.75rem" }}
                            color="#4A4A4A"
                            align="center"
                          >
                            {t("project_tasks_page.estimate")}
                          </Typography>
                        </Grid>
                      </HelperDialog>
                      <Grid
                        item
                        xs={1.8}
                        style={{
                          paddingTop: "10px",
                          marginTop: "0px",
                          background: "#CFF1AB",
                          minHeight: "36px",
                        }}
                      >
                        <HelperDialog
                          title={t(helperDialogs["projectDetail"][15].title)}
                          body={t(helperDialogs["projectDetail"][15].body)}
                          dialogIndex={15}
                          totalDialogs={helperDialogs["projectDetail"].length}
                          isOpen={activeHelperDialogIndex === 15}
                          handleNext={handleActiveHelperChange}
                          handleClose={handleClose}
                        >
                          <Typography
                            sx={{ fontSize: "0.75rem" }}
                            color="#4A4A4A"
                            align="center"
                          >
                            {t("project_tasks_page.reality")}
                          </Typography>
                        </HelperDialog>
                      </Grid>
                      <Grid
                        item
                        xs={1.9}
                        style={{
                          paddingTop: "10px",
                          marginTop: "0px",
                          background: "#DFDFDF",
                          minHeight: "36px",
                        }}
                      >
                        <Typography
                          sx={{ fontSize: "0.75rem" }}
                          color="#4A4A4A"
                          align="center"
                        >
                          {t("project_tasks_page.deviation")}
                        </Typography>
                      </Grid>
                      <Grid item xs={0.5} />

                      <Grid item xs={0.5}>
                        <HelperDialog
                          title={t(helperDialogs["projectDetail"][9].title)}
                          body={t(helperDialogs["projectDetail"][9].body)}
                          dialogIndex={9}
                          totalDialogs={helperDialogs["projectDetail"].length}
                          isOpen={activeHelperDialogIndex === 9}
                          handleNext={handleActiveHelperChange}
                          handleClose={handleClose}
                        >
                          <Typography
                            sx={{ fontSize: "0.75rem" }}
                            color="#4A4A4A"
                            align="center"
                          >
                            {t("Name")}
                          </Typography>
                        </HelperDialog>
                      </Grid>

                      <Grid item xs={1.5}>
                        <HelperDialog
                          title={t(helperDialogs["projectDetail"][10].title)}
                          body={t(helperDialogs["projectDetail"][10].body)}
                          dialogIndex={10}
                          totalDialogs={helperDialogs["projectDetail"].length}
                          isOpen={activeHelperDialogIndex === 10}
                          handleNext={handleActiveHelperChange}
                          handleClose={handleClose}
                        >
                          <Typography
                            sx={{ fontSize: "0.75rem" }}
                            color="#4A4A4A"
                            align="center"
                          >
                            {t("home.status")}
                          </Typography>
                        </HelperDialog>
                      </Grid>
                      <Grid item xs={1}>
                        <Typography
                          sx={{ fontSize: "0.75rem" }}
                          color="#4A4A4A"
                          align="center"
                        >
                          {t("project_tasks_page.registred_date")}
                        </Typography>
                      </Grid>
                      <Grid item xs={1}>
                        <HelperDialog
                          title={t(helperDialogs["projectDetail"][11].title)}
                          body={t(helperDialogs["projectDetail"][11].body)}
                          dialogIndex={11}
                          totalDialogs={helperDialogs["projectDetail"].length}
                          isOpen={activeHelperDialogIndex === 11}
                          handleNext={handleActiveHelperChange}
                          handleClose={handleClose}
                        >
                          <Typography
                            sx={{ fontSize: "0.75rem" }}
                            color="#4A4A4A"
                            align="center"
                          >
                            {t("start_date")}
                          </Typography>
                        </HelperDialog>
                      </Grid>

                      <Grid item xs={1}>
                        <HelperDialog
                          title={t(helperDialogs["projectDetail"][12].title)}
                          body={t(helperDialogs["projectDetail"][12].body)}
                          dialogIndex={12}
                          totalDialogs={helperDialogs["projectDetail"].length}
                          isOpen={activeHelperDialogIndex === 12}
                          handleNext={handleActiveHelperChange}
                          handleClose={handleClose}
                        >
                          <Typography
                            sx={{ fontSize: "0.75rem" }}
                            color="#4A4A4A"
                            align="center"
                          >
                            {t("end_date")}
                          </Typography>
                        </HelperDialog>
                      </Grid>
                      <Grid item xs={1}>
                        <HelperDialog
                          title={t(helperDialogs["projectDetail"][13].title)}
                          body={t(helperDialogs["projectDetail"][13].body)}
                          dialogIndex={13}
                          totalDialogs={helperDialogs["projectDetail"].length}
                          isOpen={activeHelperDialogIndex === 13}
                          handleNext={handleActiveHelperChange}
                          handleClose={handleClose}
                        >
                          <Typography
                            sx={{ fontSize: "0.75rem" }}
                            color="#4A4A4A"
                            align="center"
                          >
                            {t("project_tasks_page.estimated_finish_date")}
                          </Typography>
                        </HelperDialog>
                      </Grid>
                      {getTextElement(
                        t("project_tasks_page.duration"),
                        0.9,
                        t("project_tasks_page.days"),
                        "#D7EBF0",
                        "36px",
                      )}
                      {getTextElement(
                        t("estimation_page.effort"),
                        0.9,
                        t("project_tasks_page.hp"),
                        "#D7EBF0",
                        "36px",
                      )}
                      {getTextElement(
                        t("project_tasks_page.duration"),
                        0.9,
                        t("project_tasks_page.days"),
                        "#CFF1AB",
                        "36px",
                      )}
                      {getTextElement(
                        t("estimation_page.effort"),
                        0.9,
                        t("project_tasks_page.hp"),
                        "#CFF1AB",
                        "36px",
                      )}
                      {getTextElement(
                        t("estimation_page.effort"),
                        1,
                        t("project_tasks_page.days"),
                        "#DFDFDF",
                        "36px",
                      )}
                      {getTextElement(
                        t("estimation_page.effort"),
                        0.9,
                        t("project_tasks_page.hp"),
                        "#DFDFDF",
                        "36px",
                      )}
                      <Grid item xs={0.5}>
                        <Typography
                          variant="subtitle2"
                          color="#4A4A4A"
                          align="center"
                        >
                          <AddIcon fontSize="small" />
                        </Typography>
                      </Grid>
                    </Grid>
                  </Paper>

                  {elementsFiltered.map((el: any, i: number) => (
                    <ProjectDetailElementRow
                      key={el.id}
                      el={el}
                      users={usersAll}
                      idProject={projectInfo.id}
                      states={taskStates}
                      _fillProjectInfo={fillProjectInfo}
                      project={projectInfo}
                      tasks={tasks}
                      priorityTypes={priorityTypes}
                      hasSecuency={projectInfo?.has_secuency}
                    />
                  ))}
                  {projectInfo?.has_secuency == 1 && (
                    <div style={{ paddingTop: "1em" }}>
                      <Gantt
                        activities={elementsGantt}
                        fields={{
                          phases: "projectPhases",
                          tasks: "projectTasks",
                        }}
                      />
                    </div>
                  )}
                </Box>
              </HelperDialog>
            </Card>
          )}
        </TaskTypesContext.Provider>
      </Container>
    </SiteWrapper>
  );
}

export default ProjectDetailPage;
